/** 与 HistoryList / ChatUnit 一致的平台默认头像 */

export interface VisitorAvatarInput {
  avatar?: string;
  platform?: string;
  /** web 端：pc | mobile，对应 HistoryList 的 device */
  rawPlatform?: string;
  device?: string;
}

export function getVisitorAvatarSrc(input: VisitorAvatarInput): string {
  const avatar = (input.avatar || "").trim();
  const platform = (input.platform || "").toLowerCase();

  if (platform === "wechat") {
    return avatar || require("@/assets/img/wechat-avatars.png");
  }

  if (platform === "weibo") {
    return avatar || require("@/assets/img/weibo-avatars.png");
  }

  if (platform === "douyin") {
    return avatar || require("@/assets/img/douyin-avatars.png");
  }

  if (platform === "kuaishou") {
    return avatar || require("@/assets/img/kuaishou-icon.png");
  }

  if (platform === "redbook") {
    return avatar || require("@/assets/img/redbook-icon.png");
  }

  if (platform === "web") {
    const device = (input.rawPlatform || input.device || "").toLowerCase();
    if (device === "pc") {
      return avatar || require("@/assets/img/computer.png");
    }
    if (device === "mobile") {
      return avatar || require("@/assets/img/mobile.png");
    }
  }

  return avatar;
}
